import React from "react";

function Footer(props) {
  // function toggleDataBackPage(value) {
  //   props.setDisable(false);
  //   props.setOpen(false);
  //   props.setServices(value);
  // }
  function toggleModal() {
    props.setOpen(!props.open);
    props.setIsOpen(!props.isOpen);
  }
  return (
    <div>
      {/* <button
        type="button"
        className={` font-bold 
        ${
          props.isSmallerDevice
            ? "fixed bottom-[4vh] left-[30px]"
            : "left-[4.5rem] fixed bottom-[5.1rem]"
        }`}
        onClick={() => toggleDataBackPage(0)}
      >
        BACK
      </button> */}
      <button
        type="button"
        className="font-bold fixed top-16 right-[30px] lg:-bottom-[75%] lg:-left-[75%]"
        onClick={() => toggleModal()}
      >
        BACK
      </button>
    </div>
  );
}

export default Footer;
